function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', video.origin);
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', video.origin);
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function setMobileMenuState(isOpen) {
  const menu = document.getElementById('menu-mobile');
  if (!menu) return;

  if (isOpen) {
    menu.removeAttribute('aria-hidden');
    menu.removeAttribute('inert');
    trapFocus(menu);
  } else {
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    removeTrapFocus();
  }
}

function initMobileMenuDrawer() {
  const opener = document.querySelector('.js-nav-open[aria-controls="menu-mobile"]');
  const panelContainer = document.querySelector('.js-header-panel-container');
  const menu = document.getElementById('menu-mobile');

  if (!opener || !panelContainer || !menu) return;

  const open = () => {
    panelContainer.removeAttribute('aria-hidden');
    panelContainer.removeAttribute('inert');
    opener.setAttribute('aria-expanded', 'true');
    setMobileMenuState(true);
  };

  const close = () => {
    setMobileMenuState(false);
    panelContainer.setAttribute('aria-hidden', 'true');
    panelContainer.setAttribute('inert', '');
    opener.setAttribute('aria-expanded', 'false');
    opener.focus();
  };

  opener.addEventListener('click', (event) => {
    event.preventDefault();
    const isExpanded = opener.getAttribute('aria-expanded') === 'true';
    isExpanded ? close() : open();
  });

  document.addEventListener('keydown', (event) => {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (opener.getAttribute('aria-expanded') !== 'true') return;
    close();
  });

  menu.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (link) close();
  });
}

document.addEventListener('DOMContentLoaded', initMobileMenuDrawer);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    let option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  let method = options['method'] || 'post';
  let params = options['parameters'] || {};

  let form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (let key in params) {
    let hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    let value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    let value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    let raw = opt.getAttribute('data-provinces');
    let provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0; i < values.length; i++) {
      let opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }



  onVariantChange() {
    // Réinitialiser le sélecteur de quantité
    this.resetQuantitySelect();
    this.resetSelectPrevQuantity();

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.dataset.url == 'collection') {
      this.updateVariantSelectedDiv();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      // this.updateSize();
      this.updateMediaVariantStickyBar()
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      if (!this.currentVariant.available && this.dataset.url == 'collection') {
        this.addKlaviyo();
        this.updateMasterId();
        this.updateVariantInput();
        this.toggleAddButton(window.variantStrings.soldOut, !this.currentVariant.available);
      }
    }
  }

  // Au changement de variant, cette fonction remet à 0 la valeur du select quantity, (select principal + select sticky nav bar)
  resetQuantitySelect() {
    const quantitySelect = document.querySelectorAll('.main-product select[name="quantity"].select-main');
    quantitySelect.forEach(element => {

      element.selectedIndex = 0; // Sélectionner le premier élément (valeur 1)
    });
  }

  //for tracking only
  resetSelectPrevQuantity() {
    const selectPrevQuantity = document.querySelectorAll('.main-product product-form[data-select-actual-quantity]');
    selectPrevQuantity.forEach(element => {
      element.dataset.selectActualQuantity = 1;
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  // Pas utilisé car custom gallery avec double slider.
  // updateMedia() {
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;

  //   const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
  //   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

  //   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
  //   if (!modalContent) return;
  //   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
  //   modalContent.prepend(newMediaModal);
  // }

  // On change du variant, ceci met à jour la vignette featured media de la sticky nav bar.
  updateMediaVariantStickyBar() {
    if (this.dataset.url != 'collection') {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const imageVariant = document.getElementById('sticky-bar-featured-media');

    // FIX POUR LES CARD PRODUIT
    if (!imageVariant) return;

    imageVariant.src = this.currentVariant.featured_media.preview_image.src
    if(imageVariant.alt) {
      imageVariant.alt = this.currentVariant.featured_media.preview_image.alt
    }
  }
  }



  updateURL() {
    if (this.dataset.url != 'collection') {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}${this.dataset.productHandle},#product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {

      // ICI RECUP LES INFO SUR LES INPUT HIDDEN POUR UPDATE LES PROPERTIES SI ELLE EXISTE DEJA SUR LE VARIANT
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
  }

  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;

  //   if (this.currentVariant && this.currentVariant.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }

  updateSize(html) {
    const id = `size-${this.dataset.section}`;
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateVariantSelectedDiv() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    // Initialize options
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });

    this.currentVariant = this.options.find(option => option !== null);

    fieldsets.forEach((fieldset) => {
      fieldset.querySelectorAll('input').forEach((radio) => {
        radio.addEventListener('click', (e) => {

          this.currentVariant = e.target.value;

          const variantSelectedDiv = this.querySelector('.js-variant-name');
          if (!variantSelectedDiv) return;

          variantSelectedDiv.innerHTML = this.currentVariant;

          // Update unit price inside quick-add (collection cards)
          if (this.dataset.url == 'collection') {
            const variantsJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);
            const variantObj = variantsJson.find(v => v.title === this.currentVariant);
            if (variantObj) {
              this.updateCardPriceAndUnit(variantObj);
            }
          }
        });
      });
    });

    const initialVariantSelectedDiv = this.querySelector('.js-variant-name');
    if (initialVariantSelectedDiv && this.currentVariant) {
      initialVariantSelectedDiv.innerHTML = this.currentVariant;
      if (this.dataset.url == 'collection') {
        const variantsJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);
        const variantObj = variantsJson.find(v => v.title === this.currentVariant);
        if (variantObj) {
          this.updateCardPriceAndUnit(variantObj);
        }
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  // MAJ le prix des bouton add to cart, lors du select quantity change
  updateCtaMultipliedPriceValueChange() {
    // Sélectionne tous les deux select de la fiche produit : select principal et celui de la sticky nav bar
    document.querySelectorAll('select[name="quantity"].select-main').forEach((select) => {
      select.addEventListener("change", (e) => {
        const container = e.target.closest('.js-quantity-add-to-cart');
        // Obtient le prix correspondant à la variante actuelle et à la valeur sélectionnée
        const price = this.pricelist[this.currentVariant.id][e.target.value];
        container.querySelector('[data-price-style]').innerText = price;
      });
    });
  }

  renderProductInfo() {
    if (this.dataset.url != 'collection') {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);

          const destinationSticky = document.getElementById(`price-${this.dataset.section}-sticky`);
          const destinationInBtn = document.querySelectorAll(`#price-${this.dataset.section}-btn`);
          const destinationFormBtns = document.querySelectorAll(`.product-quantity-add-to-cart`);
          const destinationFormBtnSticky = document.querySelector('.product-sticky-bar .js-quantity-add-to-cart') || document.querySelector('.product-sticky-bar .product-sticky-bar__back-in-stock'); // selectionne on sticky bar neither btn 'add to cart' or 'klaviyo back in stock'

          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const sourceInBtn = html.querySelectorAll(`#price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-btn`);
          const sourceInSticky = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-sticky`);
          const sourceFormBtns = html.querySelectorAll(`.product-quantity-add-to-cart`);
          const sourceFormBtnSticky = html.querySelector('.product-sticky-bar .js-quantity-add-to-cart') || html.querySelector('.product-sticky-bar .product-sticky-bar__back-in-stock');


          if (source && destination || sourceInBtn && destinationInBtn, sourceInSticky && destinationSticky) destination.innerHTML = source.innerHTML, destinationInBtn.innerHTML = sourceInBtn.innerHTML, destinationSticky.innerHTML = sourceInSticky.innerHTML;

          // Mettre à jour destinationInBtn avec le contenu de sourceInBtn
          sourceInBtn.forEach(sourceElement => {
            destinationInBtn.forEach(destinationElement => {
              destinationElement.innerHTML = sourceElement.innerHTML;
            });
          });

          // Mettre à jour sourceInBtn avec le contenu de destinationInBtn
          destinationInBtn.forEach(destinationElement => {
            sourceInBtn.forEach(sourceElement => {
              sourceElement.innerHTML = destinationElement.innerHTML;
            });
          });

          // Met à jour le bouton de qty et d'ajout au panier dans la partie Product Info
          // l'element destination n'est pas remplacée afin que la StickyBar fonctionne
          destinationFormBtns.forEach((destinationElement, index) => {
            destinationElement.classList = sourceFormBtns[index].classList;
            destinationElement.innerHTML = sourceFormBtns[index].innerHTML;
          });

          // Met à jour le bouton de qty et d'ajout au panier dans la sticky bar
          destinationFormBtnSticky.replaceWith(sourceFormBtnSticky);

          const price = document.getElementById(`price-${this.dataset.section}`);
          const priceInBtn = document.querySelectorAll(`#price-${this.dataset.section}-btn`);
          const priceInSticky = document.getElementById(`price-${this.dataset.section}-sticky`);


          if (price) price.classList.remove('visibility-hidden');
          priceInBtn.forEach(element => {
            element.classList.remove('visibility-hidden')

          });

          if (priceInSticky) priceInSticky.classList.remove('visibility-hidden')

          const size = document.getElementById(`size-${this.dataset.section}`);

          if (size) size.classList.remove("visibility-hidden"), this.updateSize(html);

          // Update unit price line
          this.updateUnitPriceLine();

          this.toggleAddButton(window.variantStrings.soldOut, !this.currentVariant.available);
          this.updateCtaMultipliedPriceValueChange();
        });
    }
  }

  toggleAddButton(text, disable = true, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    // check if button contains only text 'add to cart' or text and price
    const addButtonText = productForm.querySelector('[name="add"] > div > span') || productForm.querySelector('[name="add"] > div');
    // select klaviyo 'Notify Me' btn
    const elKlaviyoNotifyBtn = productForm.parentElement.nextElementSibling;

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (this.dataset.url == 'collection') {
        productForm.style.display = 'none';
        if (elKlaviyoNotifyBtn.classList.contains('klaviyo-product-container')){
          elKlaviyoNotifyBtn.style.display = 'block';
        }
        document.querySelector('.klaviyo-product-container').style.display = 'block'
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (this.dataset.url == 'collection') {
        productForm.style.display = 'block';
        document.querySelector('.klaviyo-product-container').style.display = 'none'
        if (elKlaviyoNotifyBtn.classList.contains('klaviyo-product-container')){
          elKlaviyoNotifyBtn.style.display = 'none';
        }
      }
    }

    if (!modifyClass) return;
  }

  addKlaviyo() {
    if (this.dataset.url == 'collection') {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > div');

    if (!addButton) return;

    // Hide the product form
    // productForm.style.display = 'none';
    document.querySelector('.klaviyo-product-container').style.display = 'block'
    }
}

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getMetafieldData() {
    if (!this.metafieldData) {
      const metafieldScript = this.querySelector('[data-metafields]');
      if (metafieldScript) {
        this.metafieldData = JSON.parse(metafieldScript.textContent);
      }
    }
    return this.metafieldData || {};
  }

  // Consolidated function to update unit price display for both PDP and PLP using metafields
  updateUnitPrice(container, variant, options = {}) {
    try {
      if (!container || !variant) return;

      // Get metafield data from separate script - safe from existing functionality
      const metafieldData = this.getMetafieldData();
      const variantMetafields = metafieldData[variant.id];

      if (!variantMetafields) {
        container.innerHTML = '';
        return;
      }

      const unitSize = variantMetafields.size;
      const unitUom = variantMetafields.uom;

      // Only show if both metafields have values and variant has price
      if (!unitSize || !unitUom || !variant.price) {
        container.innerHTML = '';
        return;
      }

      const variantPriceCents = variant.price;
      const variantPrice = this.formatMoney(variantPriceCents / 100).replace('US$', '$');
      const pricePerUnit = variantPriceCents / 100 / unitSize;
      const formatted = this.formatMoney(pricePerUnit).replace('US$', '$');
      const titleDisplay = `${unitSize} ${unitUom}`;

      // Different styling based on context with accessibility improvements
      if (options.context === 'pdp') {
        container.innerHTML = `
          <span class='visually-hidden'>${window.variantStrings.selectedSize}: </span>
          ${window.variantStrings.selectedSize}: <strong>${titleDisplay} - </strong>
          <span aria-label='Price per ${unitUom}'>(${formatted}/${unitUom})</span>
        `;
      } else {
        // PLP card styling with accessibility
        container.innerHTML = `
          <span class='visually-hidden'>${window.variantStrings.selectSize}: </span>
          ${window.variantStrings.selectSize} : <span class='u-font-medium'>${titleDisplay}</span>
          <span class='u-text-red u-font-medium' aria-label='Total price ${variantPrice}, price per ${unitUom} ${formatted}' role='text'> - <strong>${variantPrice}</strong> (${formatted}/${unitUom})</span>
        `;
      }
    } catch (e) {
      // fail silently
    }
  }

  // Compute and display price per unit based on variant metafields
  updateUnitPriceLine() {
    const container = document.querySelector('.js-unit-price');
    if (!container) return;

    // Update visibility based on metafields for PDP
    const productSizeContainer = document.querySelector('.js-product-size-container');
    const unitPriceContainer = document.querySelector('.js-unit-price-container');
    if (productSizeContainer && unitPriceContainer) {
      // Get metafield data using the same method as updateUnitPrice
      const metafieldData = this.getMetafieldData();
      const variantMetafields = metafieldData[this.currentVariant.id];

      const hasSize = variantMetafields && variantMetafields.size && variantMetafields.size > 0;
      const hasUom = variantMetafields && variantMetafields.uom && variantMetafields.uom.trim() !== '';

      if (hasSize && hasUom) {
        productSizeContainer.classList.add('hidden');
        unitPriceContainer.classList.remove('hidden');
      } else {
        productSizeContainer.classList.remove('hidden');
        unitPriceContainer.classList.add('hidden');
      }
    }

    this.updateUnitPrice(container, this.currentVariant, { context: 'pdp' });
  }


  // Format to match storefront money format (uses the DOM to get formatted price)
  formatMoney(amountFloat) {
    // Create a temporary element using the shop's money filter by leveraging Intl
    try {
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency });
      return formatter.format(amountFloat);
    } catch (e) {
      return `$${amountFloat.toFixed(2)}`;
    }
  }

  // For PLP quick-add: update the visible price and the unit line
  updateCardPriceAndUnit(variantObj) {
    try {
      const wrapper = this.closest('.c-card-product__variants-wrapper') || document;

      // Update price in the parent card header area if present
      const card = this.closest('.c-card-product');
      if (card && typeof variantObj.price === 'number') {
        const priceEls = card.querySelectorAll('.price [data-price-style]');
        const compareEl = card.querySelector('.price [data-price-compare]');
        const formatted = this.formatMoney(variantObj.price / 100).replace('US$', '$');
        priceEls.forEach(el => (el.textContent = formatted));
        if (typeof variantObj.compare_at_price === 'number' && variantObj.compare_at_price > variantObj.price) {
          const compareFormatted = this.formatMoney(variantObj.compare_at_price / 100).replace('US$', '$');
          if (compareEl) compareEl.textContent = compareFormatted;
          card.querySelector('.price').classList.add('price--on-sale');
        } else {
          if (compareEl) compareEl.textContent = '';
          card.querySelector('.price').classList.remove('price--on-sale');
        }
      }

      // Update visibility based on metafields
      const sizeSelector = wrapper.querySelector('.js-size-selector');
      const unitPriceContainer = wrapper.querySelector('.js-unit-price-container');

      if (sizeSelector && unitPriceContainer) {
        // Get metafield data using the same method as updateUnitPrice
        const metafieldData = this.getMetafieldData();
        const variantMetafields = metafieldData[variantObj.id];

        const hasSize = variantMetafields && variantMetafields.size && variantMetafields.size > 0;
        const hasUom = variantMetafields && variantMetafields.uom && variantMetafields.uom.trim() !== '';

        if (hasSize && hasUom) {
          sizeSelector.classList.add('hidden');
          unitPriceContainer.classList.remove('hidden');
        } else {
          sizeSelector.classList.remove('hidden');
          unitPriceContainer.classList.add('hidden');
        }
      }

      // Update discount label visibility based on variant metafield
      if (card) {
        const metafieldData = this.getMetafieldData();
        const variantMetafields = metafieldData[variantObj.id];
        const discountLabel = card.querySelector('.discount-label');
        const priceWithLabelWrapper = card.querySelector('.price-with-discount-label');

        // Check if this variant should hide the discount label
        const hideLabel = variantMetafields && variantMetafields.hide_discount_label === true;

        // Only update if discount label element exists (product has discount label)
        if (discountLabel) {
          if (hideLabel) {
            // Hide the discount label
            discountLabel.style.display = 'none';
            if (priceWithLabelWrapper) {
              priceWithLabelWrapper.classList.remove('u-flex', 'u-items-center');
            }
          } else {
            // Show the discount label
            discountLabel.style.display = '';
            if (priceWithLabelWrapper) {
              priceWithLabelWrapper.classList.add('u-flex', 'u-items-center');
            }
          }
        }
      }

      // Update unit price line inside quick-add using consolidated function
      const unitEl = wrapper.querySelector('.js-card-unit-price');
      if (!unitEl) return;

      this.updateUnitPrice(unitEl, variantObj, { context: 'plp' });
    } catch (e) {}
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    if (this.dataset.mainProduct === 'true') {

      this.updateOptions()
      this.updateMasterId()
      this.getMultipliedPriceVariant()
      this.updateCtaMultipliedPriceValue()
      this.selectWithKeyBoard()
      // initial unit price render
      this.updateUnitPriceLine && this.updateUnitPriceLine()
    }
  }

  // Parse le data-price-list script qui se trouve dans le snippets/product/product-select-variant.liquid ligne 85.
  getMultipliedPriceVariant() {
    this.pricelist = JSON.parse(this.querySelector('[data-price-list]').textContent);
  }


  // MAJ le prix des bouton add to cart, lors du select quantity change
  updateCtaMultipliedPriceValue() {
    // Sélectionne tous les deux select de la fiche produit : select principal et celui de la sticky nav bar
    document.querySelectorAll('select[name="quantity"].select-main').forEach((select) => {

      // Au change d'un des select...
      select.addEventListener("change", (e) => {

        // Trouve le conteneur parent le plus proche avec la classe 'js-quantity-add-to-cart'
        const container = e.target.closest('.js-quantity-add-to-cart');
        const containerSticky = document.querySelector('.js-product-sticky-bar')


        // Obtient le prix correspondant à la variante actuelle et à la valeur sélectionnée
        const price = this.pricelist[this.currentVariant.id][e.target.value];

        // MAJ le texte de l'élément ayant l'attribut 'data-price-style' avec le nouveau prix
        container.querySelector('[data-price-style]').innerText = price;
        containerSticky.querySelector('[data-price-style]').innerText = price;

        // ACCESSIWAY:  MAJ aria label button when a quantity is selected
        const ariaLabel = `${window.variantStrings.addToCart + " - " + price}`
        container.querySelector('[name="add"]').ariaLabel = ariaLabel;
        containerSticky.querySelector('button[name="add"]').ariaLabel = ariaLabel;
      });
    });
  }

  /*
  * selectWithKeyBoard
  * enable to select variant with Enter key
  */
  selectWithKeyBoard() {
    const elLabelVariant = this.querySelectorAll('label[tabindex="0"]')
    elLabelVariant.forEach(el => {
      el.addEventListener('keyup', e => {
        if (e.which == 13) el.click()
      })
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });


    // ACCESSIWAY:  MAJ aria label button when variant is selected
    this.variantPrice = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			).dataset.variantPrice;
		});

    const buttonArialabel = document.querySelector('.js-quantity-add-to-cart button[name="add"]')
    const buttonStickyArialabel = document.querySelector('.js-product-sticky-bar button[name="add"]')
    const ariaLabel = `${window.variantStrings.addToCart + " - " + this.variantPrice[0]}`

    buttonArialabel && (buttonArialabel.ariaLabel = ariaLabel)
    buttonStickyArialabel && (buttonStickyArialabel.ariaLabel = ariaLabel)
  }
}

customElements.define('variant-radios', VariantRadios);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    // Only add event listeners if elements exist
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    if (this.elements.button) {
      this.elements.button.setAttribute('aria-expanded', 'false');
    }
    if (this.elements.panel) {
      this.elements.panel.setAttribute('hidden', true);
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    if (this.elements.button) {
      this.elements.button.focus();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value;
    }
    if (form) form.submit();
  }

  openSelector() {
    if (!this.elements.button || !this.elements.panel) return;

    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);

/**
 * Accessibility Fix: Handle focusable elements in Splide slides with aria-hidden
 * WCAG 2.1 A 4.1.2: Elements with aria-hidden="true" should not contain focusable content
 *
 * This fixes the issue where Splide slider sets aria-hidden="true" on hidden slides,
 * but focusable elements (links, buttons) inside those slides remain focusable.
 */
(function() {
  'use strict';

  // Get all focusable elements within a container (scoped to this IIFE)
  function getFocusableElementsInContainer(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

  // Store original tabindex values to restore them later
  const originalTabindexMap = new WeakMap();

  // Timeout ID for debouncing aria-hidden updates (scoped to IIFE)
  let ariaHiddenUpdateTimeout;

  // Make focusable elements non-focusable when parent has aria-hidden="true"
  function handleAriaHiddenFocusables() {
    // Find all elements with aria-hidden="true"
    const hiddenElements = document.querySelectorAll('[aria-hidden="true"]');

    hiddenElements.forEach((hiddenElement) => {
      const focusableElements = getFocusableElementsInContainer(hiddenElement);

      focusableElements.forEach((element) => {
        // Store original tabindex and make non-focusable
        if (!originalTabindexMap.has(element)) {
          const originalTabindex = element.getAttribute('tabindex');
          originalTabindexMap.set(element, originalTabindex);
          element.setAttribute('tabindex', '-1');
        }
      });
    });

    // Restore focusability for visible slides
    const allSlides = document.querySelectorAll('.splide__slide');

    allSlides.forEach((slide) => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';

      if (!isHidden) {
        const focusableElements = getFocusableElementsInContainer(slide);

        focusableElements.forEach((element) => {
          if (originalTabindexMap.has(element)) {
            const originalTabindex = originalTabindexMap.get(element);
            if (originalTabindex === null) {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', originalTabindex);
            }
            originalTabindexMap.delete(element);
          }
        });
      }
    });
  }

  // Use MutationObserver to watch for aria-hidden changes
  function initAriaHiddenObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          shouldUpdate = true;
        }
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        clearTimeout(ariaHiddenUpdateTimeout);
        ariaHiddenUpdateTimeout = setTimeout(handleAriaHiddenFocusables, 100);
      }
    });

    // Observe all Splide sliders
    const observeSliders = () => {
      const sliders = document.querySelectorAll('clrz-slider, clrz-slider-no-defer, .splide');
      sliders.forEach((slider) => {
        observer.observe(slider, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
          childList: true,
          subtree: true
        });
      });
    };

    observeSliders();

    // Re-observe when new sliders are added
    const sliderObserver = new MutationObserver(() => {
      observeSliders();
    });

    sliderObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Remove incompatible roles from <li> elements added by Splide
  function removeIncompatibleRoles() {
    // Find all <li> elements with incompatible/problematic roles
    // <li> elements should only have role="listitem" or no role (default)
    // Note: role="group" is technically allowed but conflicts with listitem semantics
    // aria-roledescription="slide" provides sufficient semantic meaning
    const incompatibleRoles = ['tabpanel', 'button', 'group'];

    incompatibleRoles.forEach((role) => {
      const incompatibleListItems = document.querySelectorAll(`li[role="${role}"]`);

      incompatibleListItems.forEach((li) => {
        // Remove the incompatible role attribute
        // The <li> will maintain its default listitem semantics
        li.removeAttribute('role');
      });
    });
  }

  // Use MutationObserver to catch dynamically added roles
  const roleObserver = new MutationObserver((mutations) => {
    const incompatibleRoles = ['tabpanel', 'button', 'group'];

    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
        const target = mutation.target;
        if (target.tagName === 'LI') {
          const role = target.getAttribute('role');
          // Remove incompatible roles from <li> elements
          if (incompatibleRoles.includes(role)) {
            target.removeAttribute('role');
          }
        }
      }
      // Also check for newly added <li> elements
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'LI') {
              const role = node.getAttribute('role');
              if (incompatibleRoles.includes(role)) {
                node.removeAttribute('role');
              }
            }
            // Check descendants
            incompatibleRoles.forEach((role) => {
              const incompatibleDescendants = node.querySelectorAll && node.querySelectorAll(`li[role="${role}"]`);
              if (incompatibleDescendants) {
                incompatibleDescendants.forEach((li) => li.removeAttribute('role'));
              }
            });
          }
        });
      }
    });
  });

  // Initialize all accessibility fixes
  function initializeAccessibilityFixes() {
    // Initialize aria-hidden focusable handling
    handleAriaHiddenFocusables();
    initAriaHiddenObserver();

    // Start observing document for role changes
    roleObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['role'],
      childList: true,
      subtree: true
    });

    // Remove incompatible roles after Splide initializes (with delay)
    setTimeout(() => {
      handleAriaHiddenFocusables();
      removeIncompatibleRoles();
    }, 500);

    // Remove incompatible roles when Splide mounts or moves
    document.addEventListener('splide:mounted', () => {
      handleAriaHiddenFocusables();
      removeIncompatibleRoles();
    });

    document.addEventListener('splide:move', () => {
      handleAriaHiddenFocusables();
      removeIncompatibleRoles();
    });
  }

  // Single DOMContentLoaded listener to avoid redundant execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAccessibilityFixes);
  } else {
    // Document already loaded, initialize immediately
    initializeAccessibilityFixes();
  }
})();